<template>
  <collapsible-widget title="ARCHIWALNY STAN MAPY" flex="1 1 0%" :accordion="accordion" :default-expanded="true">
    <b-form class="px-2 py-2">
      <b-form-row>
        <b-col>
          <v-date-picker class="w-100 mb-2" v-model="date" :max-date="new Date()" is-inline></v-date-picker>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-btn-group class="w-100">
            <b-btn variant="primary" class="w-50" @click.stop="accept">Wybierz</b-btn>
            <b-btn variant="outline-secondary" class="w-50" @click="cancel">Anuluj</b-btn>
          </b-btn-group>
        </b-col>
      </b-form-row>
    </b-form>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from "vuex";
import CollapsibleWidget from "./CollapsibleWidget";
import MapLayerBuilder from "../models/MapLayerBuilder";
import moment from "moment";

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      date: undefined,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date()
        }
      }
    };
  },
  computed: {
    ...mapGetters(["featuresLayer", "coordinateSystem", "styles"])
  },
  methods: {
    accept() {
      let styleId = this.featuresLayer.styleId;
      let style = this.styles.find(x => x.id === styleId);
      this.featuresLayer.pointInThePast = moment(this.date).unix();
      new MapLayerBuilder(this.featuresLayer, style, this.coordinateSystem).updateOlLayer(true);
      this.setLayersVisibility(this.featuresLayer, true);
    },
    cancel() {
      this.$emit("hide-historical-data");
    },
    reset() {
      this.setLayersVisibility(this.featuresLayer, false);
    },
    setLayersVisibility(layer, isHistoryMode) {
      layer.mapLayer.setVisible(!isHistoryMode);

      if (layer.mapHighResolutionLayer) {
        layer.mapHighResolutionLayer.setVisible(!isHistoryMode);
      }

      if (layer.mapHistoricalLayer) {
        layer.mapHistoricalLayer.setVisible(isHistoryMode);
      }

      if (!isHistoryMode) {
        this.featuresLayer.pointInThePast = undefined;
      }
    }
  },
  mounted() {
    this.date = new Date().toISOString();
  },
  watch: {
    featuresLayer(value, oldValue) {
      if (oldValue) {
        this.setLayersVisibility(oldValue, false);
      }

      if (value) {
        this.accept();
      }
    }
  }
};
</script>
